import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import { Selectable, SelectEventListener } from '@philips-emr/tws-core/lib/component/types';

export interface AttachmentsListItem {
  label: string;
  value: string;
}

class AttachmentsListAPI extends ComponentAPI<{ data: AttachmentsListItem[] }> implements Selectable<AttachmentsListItem> {
  /** @event */
  @AwesomeEvent
  onSelect = new SelectEventListener<AttachmentsListItem>();

  setData(data: AttachmentsListItem[]): void {
    this.setState({ data });
  }
}

export default AttachmentsListAPI;
